import type { GikBillingAddressModel } from "@gik/core/models/gik/BillingAddress";
import type { BaseUserWithLocation } from "@gik/core/models/gik/User";
import { ModalButtonFooter } from "@gik/ui-legacy/Modal";
import type { UIGenericDialogOptions } from "@gik/ui-legacy/UIManager";
import { UI } from "@gik/ui-legacy/UIManager";
import { UserBillingAddressForm } from "@gik/user-profile/components/UserBillingAddressForm/UserBillingAddressForm";

export type openAddEditUpdateModalProps = {
	user: BaseUserWithLocation;
	options?: UIGenericDialogOptions;
	billingAddress: GikBillingAddressModel;
};

export function openAddEditUserBillingAddressModal({
	user,
	options,
	billingAddress,
}: openAddEditUpdateModalProps) {
	return UI.dialog(
		({ close, footerRef }) => {
			return (
				<UserBillingAddressForm
					user={user}
					buttonsPortal={footerRef}
					onSuccess={() => close(true)}
					onCancel={close}
					billingAddress={billingAddress}
				/>
			);
		},

		{
			key: "addEditUserBillingAddressForm",
			title: (billingAddress ? "Edit" : "Add") + " Billing Address",
			closable: true,
			className: "gik-billing-address-form-modal",
			footer: <ModalButtonFooter centeredButtons />,
			...options,
		},
	);
}
